import React from 'react'
import Desc from '../LinkedDescription'

const sortWeight = -80

export default {
    border: {
        description: <Desc utility="border">border</Desc>,
        sortWeight,
        themeKey: 'borders'
    },
    borderWidth: {
        description: <Desc utility="border">border-width</Desc>,
        sortWeight,
        themeKey: 'borderWidths'
    },
    borderStyle: {
        description: <Desc utility="border">border-style</Desc>,
        sortWeight,
        themeKey: 'borderStyles'
    },
    borderColor: {
        description: <Desc utility="border">border-color</Desc>,
        sortWeight,
        themeKey: 'colors'
    },
    borderRadius: {
        description: <Desc utility="border">border-radius</Desc>,
        sortWeight,
        themeKey: 'radii'
    },
    borderTop: {
        description: <Desc utility="border">border-top</Desc>,
        sortWeight,
        themeKey: 'borders'
    },
    borderTopWidth: {
        description: <Desc utility="border">border-top-width</Desc>,
        sortWeight,
        themeKey: 'borderWidths'
    },
    borderTopStyle: {
        description: <Desc utility="border">border-top-style</Desc>,
        sortWeight,
        themeKey: 'borderStyles'
    },
    borderTopColor: {
        description: <Desc utility="border">border-top-color</Desc>,
        sortWeight,
        themeKey: 'colors'
    },
    borderTopLeftRadius: {
        description: <Desc utility="border">border-top-left-radius</Desc>,
        sortWeight,
        themeKey: 'radii'
    },
    borderTopRightRadius: {
        description: <Desc utility="border">border-top-right-radius</Desc>,
        sortWeight,
        themeKey: 'radii'
    },
    borderRight: {
        description: <Desc utility="border">border-right</Desc>,
        sortWeight,
        themeKey: 'borders'
    },
    borderRightWidth: {
        description: <Desc utility="border">border-right-width</Desc>,
        sortWeight,
        themeKey: 'borderWidths'
    },
    borderRightStyle: {
        description: <Desc utility="border">border-right-style</Desc>,
        sortWeight,
        themeKey: 'borderStyles'
    },
    borderRightColor: {
        description: <Desc utility="border">border-right-color</Desc>,
        sortWeight,
        themeKey: 'colors'
    },
    borderBottom: {
        description: <Desc utility="border">border-bottom</Desc>,
        sortWeight,
        themeKey: 'borders'
    },
    borderBottomWidth: {
        description: <Desc utility="border">border-bottom-width</Desc>,
        sortWeight,
        themeKey: 'borderWidths'
    },
    borderBottomStyle: {
        description: <Desc utility="border">border-bottom-style</Desc>,
        sortWeight,
        themeKey: 'borderStyles'
    },
    borderBottomColor: {
        description: <Desc utility="border">border-bottom-color</Desc>,
        sortWeight,
        themeKey: 'colors'
    },
    borderBottomLeftRadius: {
        description: <Desc utility="border">border-bottom-left-radius</Desc>,
        sortWeight,
        themeKey: 'radii'
    },
    borderBottomRightRadius: {
        description: <Desc utility="border">border-bottom-right-radius</Desc>,
        sortWeight,
        themeKey: 'radii'
    },
    borderLeft: {
        description: <Desc utility="border">border-left</Desc>,
        sortWeight,
        themeKey: 'borders'
    },
    borderLeftWidth: {
        description: <Desc utility="border">border-left-width</Desc>,
        sortWeight,
        themeKey: 'borderWidths'
    },
    borderLeftStyle: {
        description: <Desc utility="border">borderLeftStyle</Desc>,
        sortWeight,
        themeKey: 'borderStyles'
    },
    borderLeftColor: {
        description: <Desc utility="border">border-left-color</Desc>,
        sortWeight,
        themeKey: 'colors'
    },
    borderX: {
        description: <Desc utility="border">border-right & border-left</Desc>,
        sortWeight,
        themeKey: 'borders'
    },
    borderY: {
        description: <Desc utility="border">border-top & border-bottom</Desc>,
        sortWeight,
        themeKey: 'borders'
    }
}

